import axios from "axios";
import i18n from "@/lib/i18n";
import type { Ref } from "vue";
import type { I18n } from "vue-i18n";
import { useChangeCurrentUserLocale } from "@generated/tenant/query/tenant";
import { setLocaleCookie } from "@/lib/cookie.ts";

const supportedLocales = { pl: "Polski", en: "English", ua: "Український" };

export type Locale = keyof typeof supportedLocales;

export function useLocale(shouldMutateAsync: boolean = true) {
  const { mutateAsync } = useChangeCurrentUserLocale();

  const changeLocale = async (newLocale: Locale) => {
    changeLocaleLocally(newLocale);

    if (shouldMutateAsync) {
      await mutateAsync({ data: { locale: newLocale } });
    }
  };

  const changeLocaleLocally = (newLocale: Locale) => {
    setLocaleCookie(newLocale);

    // eslint-ignore-next-line
    ((i18n as I18n).global.locale as unknown as Ref<Locale>).value = newLocale;
    axios.defaults.headers.common["X-User-Locale"] = newLocale;

    // eslint-ignore-next-line
    document.querySelector("html")?.setAttribute("lang", newLocale);
  };

  return {
    locale: (i18n as I18n).global.locale,
    changeLocale,
    supportedLocales,
    changeLocaleLocally,
  };
}
